import * as React from "react"
import { ActionAnchor } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import env from "../../../../env"
import bem from "../../../../bem"
import { IBreadcrumbInfo } from "../../index"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    breadcrumbInfo: IBreadcrumbInfo
    level: number
}

const b = bem.with("NewUI__hierarchyItem")

export const HierarchyItem = ({
    breadcrumbInfo: {
        breadcrumb: {
            name: itemName,
            url: itemUrl,
            listName,
            listUrl,
            workspaceName,
            workspaceUrl,
        },
    },
    level,
    ...attrs
}: Props): JSX.Element => {
    const hasWorkspaceName = workspaceName.length > 0
    const hasWorkspaceLink = workspaceUrl.length > 0
    const hasList = listName && listUrl
    const hasItem = itemName && itemUrl
    const showSeparator = hasWorkspaceName && hasList
    const showTopLevel = hasWorkspaceName || hasList
    const showLevelSymbol = level > 0

    const workspaceContent = (
        <>
            {Symbols.Workspace}&nbsp;<span data-ft-name>{workspaceName}</span>
        </>
    )

    return (
        <div
            className={`${b()} tw-flex tw-items-center tw-m-3`}
            data-ft-hierarchy-level={level}
            {...attrs}
        >
            {showLevelSymbol && (
                <div className="is-dimmed tw-mr-1">
                    {Symbols.EllipsisHorizontal.repeat(level)}
                </div>
            )}

            <div className="tw-flex tw-flex-col tw-flex-1">
                {showTopLevel && (
                    <div className="label is-dimmed">
                        {hasWorkspaceName && (
                            <>
                                {hasWorkspaceLink ? (
                                    <ActionAnchor
                                        extraClasses="text-black"
                                        title={workspaceName}
                                        href={
                                            env.applicationPath + workspaceUrl
                                        }
                                        data-ft-workspace
                                        data-ft-workspace-link
                                    >
                                        {workspaceContent}
                                    </ActionAnchor>
                                ) : (
                                    <span
                                        title={workspaceName}
                                        data-ft-workspace
                                    >
                                        {workspaceContent}
                                    </span>
                                )}
                            </>
                        )}

                        {showSeparator && <>&nbsp;{Symbols.Dot}&nbsp;</>}

                        {hasList && (
                            <ActionAnchor
                                extraClasses="text-black"
                                title={listName}
                                href={env.applicationPath + listUrl}
                                data-ft-list
                            >
                                {Symbols.ListIcon}&nbsp;
                                <span data-ft-name>{listName}</span>
                            </ActionAnchor>
                        )}
                    </div>
                )}

                {hasItem && (
                    <ActionAnchor
                        title={itemName}
                        href={env.applicationPath + itemUrl}
                        data-ft-item
                    >
                        <span data-ft-name>{itemName}</span>
                    </ActionAnchor>
                )}
            </div>
        </div>
    )
}

export default HierarchyItem
